import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Room } from './rooms.model'
import { from, Observable, of } from 'rxjs'
import { flatMap, map, mergeMap, switchMap, tap, toArray } from 'rxjs/operators'
import { isEmpty } from 'lodash'

@Injectable({
  providedIn: 'root',
})
export class RoomsService {
  constructor(private http: HttpClient) {}

  getRentalRooms(rentalId: string) {
    const url = `@api/room/retrieve`

    return this.http.post<Room[]>(url, { rentals: [rentalId] })
  }

  createRoom(room: Partial<Room>) {
    const url = `@api/room/`

    return this.http.post<Room>(url, room)
  }

  createRooms(rooms: Partial<Room>[]): Observable<Room[]> {
    return of(rooms).pipe(
      flatMap((room) => from(room)),
      mergeMap((room) => this.createRoom(room)),
      toArray()
    )
  }

  upsertRooms(createRooms: Partial<Room>[], updateRooms: Partial<Room>[]): Observable<Room[]> {
    const createRooms$ = isEmpty(createRooms) ? of([]) : this.createRooms(createRooms)
    const updateRooms$ = isEmpty(updateRooms) ? of([]) : this.updateRooms(updateRooms)
    return createRooms$.pipe(
      switchMap((createdRooms) => updateRooms$.pipe(map((updatedRooms) => [...createdRooms, ...updatedRooms])))
    )
  }

  updateRoom(room: Partial<Room>) {
    const url = `@api/room/${room.pkey}`

    return this.http.put<Room>(url, room)
  }

  updateRooms(rooms: Partial<Room>[]) {
    return of(rooms).pipe(
      flatMap((room) => from(room)),
      mergeMap((room) => this.updateRoom(room)),
      toArray()
    )
  }

  deleteRoom(room: Room) {
    const url = `@api/room/${room.pkey}`

    return this.http.delete<Room>(url, {})
  }
}
